import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PlusBoxIcon from '../../assets/icons/PlusBoxIcon';
import { formatMoney } from '../../utils';

export interface BudgetHistoryWidgetProps {
  getBudget: () => Promise<{ actualExpenses: number; allocatedBudget: number, amount:number }[]>;
  isLoading?: boolean;
  hasHeader?: boolean;
}

const BudgetHistoryWidget: React.FC<BudgetHistoryWidgetProps> = ({ getBudget, isLoading, hasHeader = true }) => {
  const location = useLocation();
  const [budgetData, setBudgetData] = useState<{ actualExpenses: number; allocatedBudget: number }[]>([]);
  const [actualExpenses, setActualExpenses] = useState<null | number>(null);
  const [actualBudgetPercentage, setActualBudgetPercentage] = useState<null | number>(null);
  const [monthlyBudget, setMonthlyBudget] = useState<null | number>(null);
  const [monthlyBudgetPercentage, setMonthlyBudgetPercentage] = useState<null | number>(null);
  const [showBudget, setShowBudget] = React.useState<boolean>(false);
  

  const fetchBudgetData = async () => {
    const data = await getBudget();
    setBudgetData(data);
    setActualExpenses(data[0]?.actualExpenses ?? null);
    setMonthlyBudget(data[0]?.amount ?? data[0]?.allocatedBudget ?? null);
  };
  

  const formatValue = (value: number) => {
    return value.toLocaleString();
  };

  useEffect(() => {
    fetchBudgetData();
  }, []);

  useEffect(() => {
    if (actualExpenses !== null && monthlyBudget !== null) {
      const percentage = (actualExpenses / monthlyBudget) * 100;
      setActualBudgetPercentage(percentage > 100 ? 100 : percentage);
      setMonthlyBudgetPercentage(100 - percentage);
    }
  }, [actualExpenses, monthlyBudget]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (budgetData.length === 0) {

    return (
      <>
        <div className="flex flex-row md:gap-[10em] biglg:ml-[-0.6em] 375:ml-[0.1em] 414:ml-[1em] 820:ml-[] 412:ml-[1em] 360:ml-[-0.3em] md:ml-[0.1em] lg:ml-[-2.6em] bigmd:ml-[8.6em] xl:ml-[8em] md:justify-start xl:flex xl:gap-[113px] biglg:mt-[-0.5em] items-center xl:pl-6 xl:mt-[-1em] ml-[1em] font-normal  ">
          <h2 className="lg:text-[#000000] my-[20px] text-[14px] md:text-[16px] lg:text-[16px] xl:text-[16px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
            {location.pathname === '/dashboard' ? 'Monthly Budget vs Monthly Expense' : 'Budget vs Actual Expense'}
          </h2>
          {hasHeader && (
            <div className="flex flex-row lg:flex lg:items-center lg:gap-[4px] lg:text-[#044E97] lg:pr-[29px] lg:whitespace-nowrap">
    
            </div>
          )}
        </div>

        <div className='flex flex-col justify-center items-center md:ml-[0.1em] biglg:ml-[5.1em]  bigmd:ml-[8.7em] ml-[0.7em] 375:ml-[0.1em] 360:ml-[-0.3em] 414:ml-[1.3em]  412:ml-[1em] biglg:w-[150px] lg:w-[100px] lg:ml-[3.4em]  xl:ml-[9em] xl:w-[416px]'>

          <div className='flex items-center justify-center'>
         <div className="lg:p-4 bg-[#FFFFFF] rounded-md gap-[20px] biglg:mt-[-1.1em] xl:w-[416px] xl:h-[121px] h-[100px] w-[335px] lg:w-[300px] biglg:w-[350px] lg:h-[121px]  md:w-[580px] bigmd:w-[729px]">
          <p className="text-[#000000] text-[16px] mt-[4px] whitespace-nowrap text-center">
            You do not have any expenses. Set <br /> your budget.
          </p>
        </div> 
        </div>
        
        <div className="flex justify-center mt-[-2em] ">
          <a href="/settings?tab=expense" className="text-[#044E97] text-[16px]">
            Set a budget
            <span className="flex justify-end mt-[-1.3em] ml-[6em]">
              <PlusBoxIcon />
            </span>
          </a>
        </div>

        </div>
        
      </>
    );
  }
  return (
    <>

         <div className="flex flex-row md:gap-[10em] biglg:ml-[-0.6em] bigmd:ml-[9em] 360:ml-[-0.3em] lg:ml-[-2.8em] xl:ml-[7.9em] md:justify-start xl:flex xl:gap-[113px] items-center xl:pl-6 xl:mt-[-1em] ml-[0.4em] 414:ml-[1em] 412:ml-[1.5em] font-normal  ">
          <h2 className="lg:text-[#000000] my-[20px] text-[14px] md:text-[16px] lg:text-[16px] xl:text-[16px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
          {location.pathname === '/dashboard' ? 'Monthly Budget vs Monthly Expense' : 'Budget vs Actual Expense'}
          </h2>
        {hasHeader && (
          <div className="flex flex-row lg:flex lg:items-center lg:gap-[4px] lg:text-[#044E97] lg:pr-[29px] lg:whitespace-nowrap">

          </div>
        )}
      </div>


      <div className="  p-4  bg-[#FFFFFF]  rounded-md xl:ml-[9em] gap-[20px] xl:w-[416px] xl:h-[121px] 360:ml-[-0.3em] ml-[0.8em] 375:ml-[0.1em] 414:ml-[1em] 412:ml-[1em] biglg:mt-[-1em] biglg:ml-[-1em] bigmd:ml-[]  md:ml-[0.1em] lg:ml-[-2.6em] lg:mt-[0.5em] xl:mt-[0.5em]  h-[130px] w-[335px] lg:w-[300px] biglg:w-[350px] lg:h-[121px]  md:w-[580px] bigmd:w-[729px] ">
        <div className="top-full text-[#044E97] whitespace-nowrap text-end">
          <h1 className="text-[#828282] text-[12px]">Monthly Budget</h1>
          <div className="font-bold">{monthlyBudget ? `${formatMoney(monthlyBudget)}` : '₦0'}
          </div>
        </div>

        <div className="mt-[2px] flex items-center justify-between ">
          {monthlyBudget ? (
            <>
            
              <div
                className="relative  flex-grow-0 bg-[#D82020] w-[70%] h-[7px] "
                style={{ width: `${actualBudgetPercentage}%` }}
              />
              <div
                className="relative flex-grow-0 bg-blue-500 w-[70%] h-[7px] "
                style={{ width: `${monthlyBudgetPercentage}%` }}
              />
            </>
          ) : (
            <div className="relative flex-grow-0 bg-[#D82020] w-[70%] h-[7px] rounded-md" style={{ width: '100%' }} />
          )}
        </div>

        {actualExpenses && (
          <div className="top-full whitespace-nowrap">
            <h1 className="text-[#828282] text-[12px]">
              {location.pathname === '/dashboard' ? ' Monthly Expense' : ' Actual Expense'}
              </h1>
            <div className={`font-bold  text-[#D82020] ${!monthlyBudget ? 'text-[#D82020]' : ''}`}>
              {`${formatMoney(actualExpenses)}`}
            </div>
          </div>
        )}
      </div>
      {/* </div> */}
    </>
  );
};

export default BudgetHistoryWidget;


// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import PlusBoxIcon from '../../assets/icons/PlusBoxIcon';

// export interface BudgetHistoryWidgetProps {
//   getBudget: () => Promise<{ actualExpenses: number; amount: number }[]>;
//   isLoading?: boolean;
//   hasHeader?: boolean;
// }

// const BudgetHistoryWidget: React.FC<BudgetHistoryWidgetProps> = ({ getBudget, isLoading, hasHeader = true }) => {
//   const location = useLocation();
//   const [budgetData, setBudgetData] = useState<{ actualExpenses: number; amount: number }[]>([]);
//   const [actualExpenses, setActualExpenses] = useState<null | number>(null);
//   const [actualBudgetPercentage, setActualBudgetPercentage] = useState<null | number>(null);
//   const [monthlyBudget, setMonthlyBudget] = useState<null | number>(null);
//   const [monthlyBudgetPercentage, setMonthlyBudgetPercentage] = useState<null | number>(null);
//   const [showBudget, setShowBudget] = React.useState<boolean>(false);
  
  

//   const fetchBudgetData = async () => {
//     const data = await getBudget();
//     setBudgetData(data);
//      setActualExpenses(data[0]?.actualExpenses ?? null);
//     setMonthlyBudget(data[0]?.amount ?? null);
//   };

//   const formatValue = (value: number) => {
//     return value.toLocaleString();
//   };

//   useEffect(() => {
//     fetchBudgetData();
//   }, []);

//   useEffect(() => {
//     if (actualExpenses !== null && monthlyBudget !== null) {
//       const percentage = (actualExpenses / monthlyBudget) * 100;
//       setActualBudgetPercentage(percentage > 100 ? 100 : percentage);
//       setMonthlyBudgetPercentage(100 - percentage);
//     }
//   }, [actualExpenses, monthlyBudget]);

//   if (isLoading) {
//     return <div>Loading...</div>;
//   }
//   if (budgetData.length === 0) {
//     return (
//       <>
//         <div className="flex flex-row md:gap-[10em] lg:ml-[-2em] xl:ml-[2em] md:justify-center  xl:flex xl:gap-[113px] items-center xl:pl-6 xl:mt-[-1em] ml-[1em]   ">
//           <h2 className="lg:text-[#000000] my-[20px] lg:text-[16px] xl:text-[13px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
//             {location.pathname === '/dashboard' ? 'Monthly Budget vs Monthly Expense' : 'Budget vs Actual Expense'}
//           </h2>
//           {hasHeader && (
//             <div className="flex flex-row lg:flex lg:items-center lg:gap-[4px] lg:text-[#044E97] lg:pr-[29px] lg:whitespace-nowrap">
//             {/* <span className='flex flex-row gap-[2px] lg:ml-[0em] ml-[0.5em]  xl:ml-[2em] md:ml-[-14px] text-[#044E97]  '>
//             <h3 className="text-[12px] lg:text-[16px] font-semibold">View</h3>
//             <h3 className="text-[12px] lg:text-[16px] font-semibold">History</h3>
//             </span> */}
//               {/* {<PlusBoxIcon />} */}
//             </div>
//           )}
//         </div>

//         <div className='flex flex-col justify-center items-center lg:ml-[16em] lg:w-[150px] xl:ml-[9em] xl:w-[200px]'>

//           <div className='flex items-center justify-center'>
//          <div className="lg:p-4 bg-[#FFFFFF] xl:ml-[2em] rounded-md gap-[20px] xl:w-[416px] h-[100px] w-[280px] lg:w-[358px]  md:w-[448px]">
//           <p className="text-[#000000] text-[16px] mt-[4px] ml-[14px] whitespace-nowrap text-center">
//             You do not have any expenses. Set <br /> your budget.
//           </p>
//         </div> 
//         </div>
        
//         <div className="mt-[-2em]">
//           <a href="/settings?tab=expense" className="text-[#044E97] flex justify-center text-[16px]">
//             Set a budget
//             <span className="ml-2">
//               <PlusBoxIcon />
//             </span>
//           </a>
//         </div>
//         </div>
        
//       </>
//     );
//   }
//   return (
//     <>
//       <div className="flex gap-[113px] pl-6 justify-between items-center mb-[8px] xl:mt-[-1em] lg:mt-[em]">
//         <h2 className="md:mt-[1em] xl:text-[#000000] xl:text-[13px] text-[14px] ml-[1.7em] xl:ml-[2.7em] mt-[1em] md:ml-[8em]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
//           {location.pathname === '/dashboard' ? 'Monthly Budget vs Monthly Expense' : 'Budget vs Actual Expense'}
//         </h2>
//         {hasHeader && (
//           <div className="flex flex-row lg:flex lg:items-center lg:gap-[4px] lg:text-[#044E97] lg:pr-[29px] lg:whitespace-nowrap">
//             {/* <span className='flex flex-row gap-[3px] ml-[-5em]  md:ml-[-14em] lg:ml-[-33em] xl:ml-[2em] text-[#044E97]'>
//             <h3 className="text-[12px] lg:text-[16px] font-semibold">View</h3>
//             <h3 className="text-[12px] lg:text-[16px] font-semibold">History</h3>
//             </span> */}

//             {/* <span>{<PlusBoxIcon />}</span>  */}
//           </div>
//         )}
//       </div>

//       <div className="  p-4  bg-[#FFFFFF]  rounded-md xl:ml-[2em]  gap-[20px] xl:w-[400px] w-[270px] ml-[1em] h-[126px] md:w-[448px] md:ml-[9em] lg:w-[358px] lg:mt-[1em] ">
//         <div className="top-full text-[#044E97] whitespace-nowrap text-end">
//           <h1 className="text-[#828282] text-[12px]">Monthly Budget</h1>
//           <div className="font-bold">{monthlyBudget ? `₦${formatValue(monthlyBudget)}` : '₦0'}
//           </div>
//         </div>

//         <div className="mt-[2px] flex items-center justify-between ">
//           {monthlyBudget ? (
//             <>
            
//               <div
//                 className="relative  flex-grow-0 bg-[#D82020] w-[70%] h-[7px] "
//                 style={{ width: `${actualBudgetPercentage}%` }}
//               />
//               <div
//                 className="relative flex-grow-0 bg-blue-500 w-[70%] h-[7px] "
//                 style={{ width: `${monthlyBudgetPercentage}%` }}
//               />
//             </>
//           ) : (
//             <div className="relative flex-grow-0 bg-[#D82020] w-[70%] h-[7px] rounded-md" style={{ width: '100%' }} />
//           )}
//         </div>

//         {actualExpenses && (
//           <div className="top-full whitespace-nowrap">
//             <h1 className="text-[#828282] text-[12px]">
//               {location.pathname === '/dashboard' ? ' Monthly Expense' : ' Actual Expense'}
//               </h1>
//             <div className={`font-bold  text-[#D82020] ${!monthlyBudget ? 'text-[#D82020]' : ''}`}>
//               {`₦${formatValue(actualExpenses)}`}
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default BudgetHistoryWidget;
